
const underconstruction = [
    {
        "key": "underconstruction.title",
        "string": "Seite im Aufbau"
    },
    {
        "key": "underconstruction.text",
        "string": "Diese Seite befindet sich derzeit noch im Aufbau. Weitere Inhalte folgen in Kürze!"
    }
]

export default underconstruction



// WEBPACK FOOTER //
// ./src/i18n/de/landingpage/underconstruction.js